<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="3" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        subtitle:'ProBeam<sup>®</sup> 360° System',
        videosrc:'P02.mp4',
        title:'ProBeam<sup>®</sup> 360° 質子治療系統',
        list:[
          {
            body:"Varian ProBeam<sup>®</sup> 360°質子治療系統為目前瓦里安最新的質子治療解決方案，包含單室和多室解決方案，搭配最新強度調控質子治療技術，可依據腫瘤形狀進行塑造。保持360度旋轉機架的同時，體積減少50%、占地面積減少了 30%、建築成本減少約 25% ，仍可提供無與倫比的臨床功能，且支援下一代治療方式Flash 療法。RapidPlan PT人工智慧計畫也將很快進入市場，在保障計畫品質的同時，計畫時間從幾個小時降低至10分鐘以內，進一步提高效率。"
          },
          {
            body:"Flash 是採用高劑量超高速 （低於1 秒） 的體外非侵入束流治療，僅需1-3次治療。臨床前研究表明，相較於傳統質子治療，該療法在保障腫瘤控制率的同時，極大降低了健康組織副反應並可能提升免疫治療效益。這一新療法具有光明的前景，也代表了未來癌症治療的新方向。"
          }

        ]
      }

    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
